import Vue from 'vue'
import moment from 'moment'

Vue.prototype.$moment = moment

export default function({ app }) {
  const locale = app.i18n.locale
  moment.locale(locale)
}
